import React, { useEffect } from 'react';
import Arise4uBlackLogo from '../../assets/images/arise logo-01 1.svg';
import FailureTransactionImage from '../../assets/images/Failure Icon.svg';
import Modal from 'react-bootstrap/Modal';




const PaymentFailureModal = ({ id, onClose, show = false, onSubmit }) => {
  
  const handleUploadClick = () => {
    onSubmit();
  }

  return (
    <>
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
        <Modal.Header>
          <div className="logo-box">
              <img
                src={Arise4uBlackLogo}
                alt="Arise4u Black Logo"
                className="arise4u-black-logo"
              />
            </div>
            <button
              type="button"
              className="btn-close1 font-bold fs-5"
              onClick={onClose}
            >
              X
            </button>
        </Modal.Header>
        <Modal.Body>
           <div className='popup-qrcode-title-box mt-minus-60 d-flex flex-column justify-content-center align-items-center'>
              <img
                src={FailureTransactionImage}
                alt='Success Transaction Image'
                className='popup-payment-success-img'
              />
              <p className='font-bold text-center txt-blue fs-2 mb-0'>Your payments screenshot has</p>
              <p className='font-bold text-center txt-blue fs-2 mb-0 mt-minus-10'>failed to be uploaded</p>

            </div>
            <div className='popup-qrcode-btn-box d-flex justify-content-center align-items-center py-3 '>
              <div className='btn-design d-flex justify-content-center align-items-center cursor-pointer' onClick={handleUploadClick}>
                <p className='mb-0 txt-white font-regular-four fs-5'>Try again</p>
                <svg className='ms-2' width="20" height="20"  data-name="Layer 1" fill='white' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4.38 12.19 8.57 8 4.38 3.81l1.53-1.52L11.62 8l-5.71 5.71-1.53-1.52z"/></svg>
              </div>
            </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaymentFailureModal;

